import React from "react";
import Paginationguidelines1 from "assets/images/png/Paginationguidelines1.png";
import Paginationguidelines2 from "assets/images/png/Paginationguidelines2.png";

const ComponentPrimaryDatas = [
	{
		id: 1,
		title: "Do",
		titleClassname: "active",
		image: Paginationguidelines1,
		description:
			"Place dropdowns to the left, aligning them with the top edge for clarity. Maintain consistent spacing between the dropdown and input field.",
	},
	{
		id: 2,
		title: "Don’t",
		titleClassname: "inactive",
		image: Paginationguidelines2,
		description:
			"Avoid placing dropdowns above, below, or misaligned to the left of the input fields. Ensure dropdowns are not too close or too far from the input fields for optimal readability.",
	},
];

const GuidelineCardPagination = () => {
	return (
		<div className="guideline-card d-flex justify-content-between">
			{ComponentPrimaryDatas.map((data) => (
				<div key={data.id} className="guideline-wrapper">
					<h6 className={`guideline-badge plt-body-compact-md dis-mb-8 ${data.titleClassname}`}>{data.title}</h6>
					<div className="guideline-detail-wrapper d-flex align-items-center justify-content-center">
						<div className="guideline-img">
							<img src={data.image} alt="userimage" />
						</div>
					</div>
					<p className="guideline-desc plt-body-md dis-mt-12">{data.description}</p>
				</div>
			))}
		</div>
	);
};

export default GuidelineCardPagination;
